import { isFromPublicSharePage, getParam } from 'utilities/url';
import { VIDEO_CTA_CLICKED } from 'constants/events';
import { trackCtaClick } from 'utilities/video-session/mediaAnalyticsEvent';

interface CtaEventParams {
  videoId: string;
  sessionId: string;
  isOwner: boolean;
}

function trackCtaEvent(params: CtaEventParams): void {
  const { videoId, sessionId, isOwner } = params;
  const { fromPublicSharePage, parentLocation } = isFromPublicSharePage();
  const fromUrl = window.decodeURIComponent(getParam('from_url') || '');

  trackCtaClick(videoId, sessionId);

  analytics.track(VIDEO_CTA_CLICKED, {
    // This need to be updated when we work on embedding the player for the share page
    // is_inline_embed_on_loom: isInlineEmbedOnLoom,
    from_public_share_page: fromPublicSharePage,
    is_inline_embed_on_loom: false,
    parent_location: parentLocation || fromUrl,
    video_id: videoId,
    owner_click: isOwner,
  });
}

export default trackCtaEvent;
